import cx from 'classnames'
import Parser from 'html-react-parser'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'

import { DownArrowIcon, EqualArrowIcon, UpArrowIcon, UrgentIcon } from '../../../../assets/svgs/components'
import { useClickOutside } from '../../../../hooks'
import { Divider } from '../../../shared/Divider'
import { Checkbox } from '../../../shared/NarusMaterial'
import { useIGAO } from '../../context'
import { SaveOnPress, DatapickerUrgent, Domain } from '../../shared'
import {
  uid,
  prepareStatus,
  notEditableItem,
  isFavorable,
  cancelledOrCompleted,
  detailsFields,
  itemDetails,
  findDiff as findDiffFunc,
  validateNewAction,
  templateNewAction
} from '../../utils'
import { ActionIcons } from '../action-icons'
import { Actions } from '../actions'
import { Edit } from '../selects'
import { Textarea } from '../textarea'

import styles from './issue.module.scss'

const openDays = issue => {
  const diff = moment().diff(issue.createdAt, 'days')
  if (diff === 0) {
    return 'Today'
  }
  if (diff > 1) {
    return `${diff} days`
  }
  return `${diff} day`
}

const trendIcons = {
  Trend: 'Trend',
  Unchanged: <EqualArrowIcon title='Unchanged' />,
  Improving: (
    <UpArrowIcon
      color='#80b700'
      title='Improving'
    />
  ),
  Worsening: (
    <DownArrowIcon
      color='#f90d16'
      title='Worsening'
    />
  )
}

const actionDetails = [
  {
    id: 'cgassstiqz10c8m4of8swsc1k4iu8s',
    key: 'assignee',
    type: 'select',
    label: 'assignee',
    values: []
  },
  {
    id: 'cgassstiqz22nljrt7ob6u1txv2h0',
    key: 'status',
    type: 'select',
    label: 'status',
    values: []
  }
]

function IssueDetails ({
  editMode,
  values,
  classNames,
  issue,
  item,
  variableParams,
  editLocalIssue,
  openEditView
}) {
  const { pageData: { user: { id: userId }, lists, metadata: { trend } }, page } = useIGAO()
  const setUrgentColor = () => {
    if (issue.urgent) {
      return '#FF5741'
    }
    return 'transparent'
  }

  if (page === 'tasks') {
    return (
      <>
        <button
          className={cx(styles.assignee, styles.content)}
          onClick={openEditView}
        >
          <span className={classNames.assignee}>{values.assignee}</span>
        </button>
        <button
          className={cx(styles.patient, styles.content)}
          onClick={openEditView}
        >
          <span>{issue?.patient?.lastName} {issue?.patient?.firstName}</span>
        </button>
        <button
          className={cx(styles.issueStatus, styles.content)}
          onClick={openEditView}
        >
          <span className={classNames.status}>{values.status}</span>
        </button>
        {trend && (
          <button
            className={cx(styles.trend, styles.content)}
            onClick={openEditView}
          >
            <span className={classNames.trend}>{trendIcons[values.trend]}</span>
          </button>
        )}
        <button
          className={styles.daysAction}
          onClick={openEditView}
        >
          <div className={cx(styles.days, styles.content)}>{openDays(issue)}</div>
          <div style={{ marginTop: '5px' }}>
            <UrgentIcon fill={setUrgentColor()} />
          </div>
        </button>
      </>
    )
  }

  if (!editMode) {
    return (
      <>
        <button
          className={cx(styles.assignee, styles.content)}
          onClick={openEditView}
        >
          <span className={classNames.assignee}>{values.assignee}</span>
        </button>
        <button
          className={cx(styles.issueStatus, styles.content)}
          onClick={openEditView}
        >
          <span className={classNames.status}>{values.status}</span>
        </button>
        {trend && (
          <button
            className={cx(styles.trend, styles.content)}
            onClick={openEditView}
          >
            <span className={classNames.trend}>{trendIcons[values.trend]}</span>
          </button>
        )}
        <button
          className={styles.daysAction}
          onClick={openEditView}
        >
          <div className={cx(styles.days, styles.content)}>{openDays(issue)}</div>
          <div style={{ marginTop: '5px' }}>
            <UrgentIcon fill={setUrgentColor()} />
          </div>
        </button>
      </>
    )
  }

  return (
    <>
      {itemDetails(trend).map(
        detail =>
          detail.type === 'select' && (
            <div
              className={styles.selects}
              key={detail.key}
              style={{ gridArea: detail.key }}
            >
              <Edit
                edit={editMode}
                currentUser={userId}
                lists={lists}
                relation={detail}
                currentAssignee={variableParams.assignee}
                itemId={item.id}
                disabled={isFavorable(item)}
                handler={editLocalIssue}
                detail
                nullable={detail?.key === 'trend'}
                selected={{
                  key: detail.key,
                  id: variableParams[detail.key]
                }}
              />
            </div>
          )
      )}
      <div className={styles.daysAction}>
        <div className={cx(styles.days, styles.content)}>{openDays(issue)}</div>
        <div style={{ alignSelf: 'center' }}>
          <UrgentIcon fill={setUrgentColor()} />
        </div>
      </div>
    </>
  )
}

export function Issue ({
  issue,
  item,
  editId,
  setEditId,
  handleInputSubmit,
  handleBatch,
  setSelectedIssueId,
  selected
}) {
  const {
    pageData: { user, lists, metadata: { trend } },
    createAction,
    batch,
    page,
    editIssue,
    deleteIssue,
    masterBatch,
    compactView
  } = useIGAO()
  const editMode = editId === issue.id
  const domain = issue.domain || item.domain
  const [ action, setAction ] = useState({
    text: '',
    urgent: false,
    status: 'in-progress',
    assignee: user?.id,
    dueDate: moment(new Date()).add(1, 'days')
  })
  const [ changedRelations, setChangedRelations ] = useState({})
  const [ variableParams, setVariableParams ] = useState({
    assignee: issue.details.find(rel => rel.key === 'assignee').id,
    description: issue.description,
    status: issue.details.find(rel => rel.key === 'status').id,
    trend: issue.details.find(rel => rel.key === 'trend')?.id
  })
  const [ addAction, setAddAction ] = useState(false)
  const [ shiftDown, setShiftDown ] = useState(null)
  const actionSaveRef = useRef(null)
  const issueRef = useRef(null)
  const stateRef = useRef()

  stateRef.current = {
    variableParams,
    changedRelations,
    action,
    issue
  }

  useEffect(() => {
    setVariableParams(() => ({
      assignee: issue.details.find(rel => rel.key === 'assignee').id,
      description: issue.description,
      status: issue.details.find(rel => rel.key === 'status').id,
      trend: issue.details.find(rel => rel.key === 'trend')?.id
    }))
  }, [ issue ])

  const saveData = () => {
    const changedDetails = {}
    if (stateRef.current.variableParams.description !== issue.description) {
      changedDetails.description = stateRef.current.variableParams.description
    }
    if (
      stateRef.current.variableParams.assignee !==
      issue.details.find(rel => rel.key === 'assignee').id
    ) {
      changedDetails.assignee = stateRef.current.variableParams.assignee
    }
    if (
      stateRef.current.variableParams.status !==
      issue.details.find(rel => rel.key === 'status').id
    ) {
      changedDetails.status = stateRef.current.variableParams.status
    }
    if (
      stateRef.current.variableParams.trend !==
      issue?.details?.find(rel => rel.key === 'trend')?.id
    ) {
      changedDetails.trend = stateRef.current.variableParams.trend
    }

    if (
      Object.prototype.hasOwnProperty.call(stateRef.current.changedRelations, 'details') &&
      stateRef.current.changedRelations.details.length < 1
    ) {
      return
    }

    editIssue(
      item.id,
      issue.id,
      changedDetails,
      stateRef.current.changedRelations
    )
    setChangedRelations({})
    setEditId(null)
  }

  const prepareIssueDescription = description => {
    if (issue?.diff?.description) {
      const { current, previous } = issue.diff.description
      const currentRelations = [ ...current.matchAll('<span[^>]*>[^>]*<\\/span>') ]
      const previousRelations = [ ...previous.matchAll('<span[^>]*>[^>]*<\\/span>') ]
      const spans = Array.isArray(description) ? description?.filter(el => el?.type === 'span') : []
      currentRelations.map((v, k) => {
        if (v?.[0] !== previousRelations[k]?.[0]) {
          spans[k].props.style.color = '#e38d00'
          spans[k].props.style.background = '#f8e8c0'
          spans[k].props.style['border-radius'] = '16px'
          spans[k].props.style.padding = '3px 11px'
          spans[k].props.style.fontWeight = '500'
        }
        return v
      })
    }
    return description
  }

  const onEditIssue = (key, id, detail) => {
    if (!detail) {
      const oldRelationId = issue.relations.find(rel => rel.key === key).id
      setChangedRelations(prev => ({
        ...prev,
        [key]: detailsFields.includes(key)
          ? id
          : {
            oldValue: oldRelationId,
            newValue: id
          }
      }))
      return
    }

    const statusID = issue.details.find(d => d.key === 'status').id
    const status = prepareStatus(key, id, user?.id, statusID)
    setVariableParams(prev => ({
      ...prev,
      [key]: id,
      status
    }))
  }

  useClickOutside(issueRef, () => {
    saveData()
  })

  const onCreateAction = () => {
    if ((stateRef.current.action.text?.trim() || '').length === 0) return true
    if (validateNewAction(stateRef.current.issue, stateRef)) {
      const newAction = templateNewAction(stateRef, lists)
      createAction(item.id, issue.id, newAction)
      setAction({
        ...stateRef.current.action,
        text: '',
        urgent: false
      })
      return true
    }

    toast.error('Can\'t create duplicate action', { position: 'bottom-center' })
    return false
  }

  useClickOutside(actionSaveRef, () => {
    const res = onCreateAction()
    if (res) setAddAction(false)
  })

  const closeCreateAction = () => {
    setAction({
      text: '',
      urgent: false,
      status: 'not-started',
      assignee: user?.id,
      dueDate: moment(new Date()).add(1, 'days')
    })
    setAddAction(false)
  }

  const handleKeyDownAction = e => {
    if (e.keyCode === 16 || e.charCode === 16) {
      setShiftDown(true)
    }
    if (e.keyCode === 27) {
      closeCreateAction()
    }
  }

  const handleKeyUp = e => {
    if (e.keyCode === 16 || e.charCode === 16) {
      setShiftDown(false)
    }
  }

  const setOpenAddAction = e => {
    e.stopPropagation()
    setAddAction(!addAction)
  }

  const handleChanges = (key, value) => {
    const status = prepareStatus(key, value, user?.id, action.status)

    setAction({
      ...action,
      [key]: value,
      status
    })
  }

  const handleChangeDate = date => {
    let dueDate
    try {
      dueDate = new Date(date).toISOString()
    } catch (err) {
      return
    }

    setAction(prev => ({
      ...prev,
      dueDate
    }))
  }

  const handleKeyPress = e => {
    if (e.keyCode === 13 || (e.charCode === 13 && !shiftDown)) {
      e.preventDefault()
      onCreateAction()
    }
  }

  const handleKeyPressEdit = e => {
    if (e.keyCode === 13 || (e.charCode === 13 && !shiftDown)) {
      e.preventDefault()
      saveData()
    }
    if (e.keyCode === 27 || e.charCode === 27) {
      setVariableParams(() => ({
        assignee: issue.details.find(rel => rel.key === 'assignee').id,
        description: issue.description,
        status: issue.details.find(rel => rel.key === 'status').id,
        trend: issue.details.find(rel => rel.key === 'trend')?.id
      }))
      setChangedRelations({})
      setEditId(null)
    }
  }

  const notEditableIssue = notEditableItem(issue)

  function openEditView (e) {
    e.stopPropagation()
    if (window.getSelection().toString().length) {
      return
    }

    if (e.target.type !== 'checkbox') {
      if (!notEditableIssue) setEditId(issue.id)
    }
  }

  function handleSelectChange (key, value) {
    handleChanges(key, value)
  }

  const findDiff = key => findDiffFunc(issue, key)

  const status = lists.status.find(l => l.id === variableParams?.status)?.name ?? 'Status'

  const assignee = lists.assignee.find(l => l.id === variableParams?.assignee)?.name ?? 'Assignee'

  const trendValue = lists.trend.find(l => l.id === variableParams?.trend)?.name ?? 'Trend'

  const description = prepareIssueDescription(Parser(issue?.description || ''))

  const active = ![ 'completed', 'cancelled' ].includes(variableParams.status)

  const values = {
    assignee,
    status,
    active,
    trend: trendValue
  }

  function actionView () {
    if (!(!notEditableIssue && values.active && !compactView && page !== 'tasks')) {
      return null
    }

    if (editMode) {
      return null
    }

    if (!addAction) {
      return (
        <div className={styles.addActionBtnGrid}>
          <button
            className={styles.actionAddContainer}
            onClick={e => setOpenAddAction(e)}
          >
            <span>Add Action</span>
          </button>
        </div>
      )
    }

    return (
      <button
        className={styles.actionAddContainer}
        onClick={e => e.stopPropagation()}
      >
        <SaveOnPress
          onKeyPress={handleKeyPress}
          onKeyDown={handleKeyDownAction}
          saveRef={actionSaveRef}
          editable
          focus={false}
        >
          <div className={cx(styles.addActionGrid, { [styles.trend]: trend })}>
            <div />
            <div />
            <button className={styles.descriptionInput}>
              <Textarea
                onChange={value => handleChanges('text', value)}
                onKeyUp={handleKeyUp}
                onKeyDown={handleKeyDownAction}
                value={action.text}
                focus
                placeholder='Free Text Action'
              />
            </button>
            {actionDetails.map(detail => (
              <div
                className={styles.selects}
                key={detail.key}
              >
                <Edit
                  currentUser={user?.id}
                  relation={detail}
                  lists={lists}
                  currentAssignee={action.assignee}
                  itemId={item.id}
                  disabled={isFavorable(item)}
                  handler={handleSelectChange}
                  detail
                  selected={{
                    id: action[detail.key],
                    key: detail.key
                  }}
                />
              </div>
            ))}
            <DatapickerUrgent
              value={action.dueDate}
              urgent={action.urgent}
              handleChangeUrgent={handleChanges}
              handleChangeDate={handleChangeDate}
              add
            />
          </div>
        </SaveOnPress>
      </button>
    )
  }

  const selectedRel = rel => {
    const isInput = rel.type === 'input'

    return {
      id: isInput
        ? Object.prototype.hasOwnProperty.call(changedRelations, rel.key)
          ? changedRelations[rel.key]
          : issue.relations.find(_rel => rel.key === _rel.key).value
        : changedRelations[rel.key]?.newValue ||
          issue?.relations.find(f => f.key === rel.key).id,
      key: rel.key
    }
  }

  const classNames = {
    assignee: cx({ [styles.modified]: findDiff('assignee') }),
    trend: cx({ [styles.modified]: findDiff('trend') }),
    status: cx({
      [styles.modified]: findDiff('status'),
      [styles[variableParams.status]]: !issue.draft && findDiff('status')
    })
  }

  return (
    <div
      id={issue.id}
      className={cx(styles.issueItem, { [styles.draft]: issue.draft, [styles.notEditable]: notEditableIssue })}
      ref={editMode ? issueRef : null}
    >
      <SaveOnPress
        onKeyPress={handleKeyPressEdit}
        onKeyDown={handleKeyPressEdit}
        saveRef={actionSaveRef}
        editable={editMode}
      >
        <IssueWrapper
          batchCheck={issue?.batchCheck}
          editMode={editMode}
          draft={issue.draft}
        >
          <IssueContainer>
            <div className={cx('issue-checkbox', styles.leftGroup, styles.checkbox, styles.content)}>
              <Checkbox
                value={masterBatch || batch.includes(issue.id)}
                disabled={cancelledOrCompleted(issue)}
                onClick={e => {
                  e.cancelBubble = true
                  if (e.stopPropagation) e.stopPropagation()
                }}
                data-cy='select_issue-checkbox'
                onChange={() => handleBatch(item.id, issue.id)}
              />
            </div>
            <Domain
              domain={domain}
              lists={lists}
            />

            <button
              className={styles.description}
              onClick={openEditView}
            >
              {description}
            </button>
            <IssueDetails
              item={item}
              issue={issue}
              editMode={editMode}
              classNames={classNames}
              values={values}
              openEditView={openEditView}
              editLocalIssue={onEditIssue}
              variableParams={variableParams}
            />
            {deleteIssue && setSelectedIssueId && (
              <ActionIcons
                isIssue
                className={styles.actionsIcon}
                deleteFn={() => deleteIssue?.(item.id, issue)}
                onClick={setSelectedIssueId}
                selected={selected}
                item={issue}
              />
            )}
          </IssueContainer>

          <div className={styles.editIssueRelations}>
            {editMode && issue.draft && (
              <div className={cx(styles.selects, styles.editIssue)}>
                {item?.relations?.map(rel => (
                  <Edit
                    key={rel.id}
                    relation={rel}
                    lists={lists}
                    itemId={item.id}
                    issues={item.issues}
                    disabled={isFavorable(item) || !issue.draft}
                    handler={onEditIssue}
                    selected={selectedRel(rel)}
                  />
                ))}
              </div>
            )}
          </div>

          {!editMode && !compactView && (
            <div className={styles.goalGrid}>
              <span className={styles.goal}>
                GOAL:{' '}{issue.goal || item.goal}
              </span>
            </div>
          )}
          {actionView()}
        </IssueWrapper>
      </SaveOnPress>
      {issue?.actions?.length > 0 && !compactView && (
        <>
          <Divider />
          <Actions
            item={item}
            issue={issue}
            shiftDown={shiftDown}
            handleBatch={handleBatch}
            handleKeyUp={handleKeyUp}
            handleKeyDown={handleKeyDownAction}
            closeCreateAction={closeCreateAction}
            handleInputSubmit={handleInputSubmit}
            uid={uid}
            setSelectedIssue={setSelectedIssueId}
            selected={selected}
          />
        </>
      )}
    </div>
  )
}

export function IssueContainer ({ children }) {
  const { page, pageData: { metadata: { trend } } } = useIGAO()

  return (
    <div
      className={cx(styles.issueContainer, {
        [styles.trend]: trend,
        [styles.careplan]: page === 'careplan',
        [styles.tasks]: page === 'tasks'
      })}
    >
      {children}
    </div>
  )
}

export function IssueWrapper ({ children, editMode, batchCheck, draft }) {
  return (
    <div
      className={cx(styles.issue, {
        [styles.editMode]: editMode && !batchCheck,
        [styles.draft]: draft
      })}
      data-cy={`issue${draft ? '-draft' : ''}`}
    >
      {children}
    </div>
  )
}
